import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UploaderComponent} from '../../uploader';
import {debounceTime, switchMap, takeUntil} from 'rxjs/operators';
import {NzModalService, TransferItem} from 'ng-zorro-antd';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {$e} from 'codelyzer/angular/styles/chars';
import {DistributorsService, RootService} from '../../../services';
import {capitalizeFirstLetter, removeAllSpacingBetweenWords} from '../../../helpers';
import {DomSanitizer} from '@angular/platform-browser';
import {HandleVideo} from '../../common/handle-video';

@Component({
  selector: 'add-distributors',
  templateUrl: './add-distributors.component.html',
  styleUrls: ['./add-distributors.component.scss']
})
export class AddDistributorsComponent extends HandleVideo implements OnInit, OnDestroy {
  isVisible = false;
  actions = [
    {label: 'Gán sản phẩm', value: 0},
    {label: 'Gỡ sản phẩm', value: 1},
    {label: 'Export', value: 2},
    {label: 'Export tất cả', value: 3},
  ];
  index = 1;
  title;
  list: TransferItem[] = [];
  searchPlaceholder = 'Tên hoặc mã sản phẩm';
  itemsUnit = 'Sản phẩm';
  pageIndex = 1;
  pageSize = 5;
  changeTabEvent = 1;
  countries: any;
  name= ''
  name1= ''
  tax= ''
  address= ''
  phoneNumber= ''
  email= ''
  website= ''
  // country_id: any;
  // tslint:disable-next-line:variable-name
  country_code: any;
  city = [];
  cityNew = [];
  districts = null;
  street = null;
  listWard = [];
  unsubscribe$ = new Subject<void>();
  avatar: any[] = [];
  background: any[] = [];
  introImage: any[] = [];
  introVideo: any[] = [];
  // tslint:disable-next-line:variable-name
  form_step: FormGroup = this.fb.group({
    id: [null, [Validators.required]],
  });
  public config = {
    placeholder: '',
    tabsize: 2,
    height: '250px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      // ["insert", ["link", "video"]],
      ['insert', ['link']],
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],
    disableDragAndDrop: true

  };
  @Output() loadDataParent = new EventEmitter();
  optionList: any;
  isLoading = false;
  searchChange$ = new BehaviorSubject('');
  viewDetail;
  isLoadingBtn = false;

  constructor(
    public fb: FormBuilder,
    public modalService: NzModalService,
    public notification: NzNotificationService,
    public distributorsService: DistributorsService,
    public rootService: RootService,
    public modal: NzModalService,
    public sanitizer: DomSanitizer
  ) {
    super(modalService, fb, sanitizer, modal, notification, rootService);
    const optionList$: Observable<string> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500));

    optionList$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {

      if (value && value.trim().length > 0) {
        const query = {
          name: value.trim()
        };
        this.distributorsService.searchDistributor(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
          this.optionList = res.items;
          this.isLoading = false;
        });
      } else {
        this.optionList = [];
        this.isLoading = false;

      }

    });
  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.getCities();
    this.rootService.listCities().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.city = res.data.items;
      // console.log("this.city", this.city)
    });

    this.rootService.getLocationNew({
      type: 1
    }).subscribe((res) => {
      this.cityNew = res.data.data;
      // console.log("this.city2", this.city)
    });
    this.form_step1.controls.province_id.clearValidators();
    this.form_step1.controls.province_id.disable();
    this.form_step1.controls.district_id.clearValidators();
    this.form_step1.controls.district_id.disable();
    this.form_step1.controls.streetId.clearValidators();
    this.form_step1.controls.streetId.disable();


    this.form_step1.get('provinceNewId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      if (val) {
        this.rootService.getLocationNew({
          type: 2,
          parentId: val
        }).subscribe((res: any) => {
          if (res.code === 1) {
            this.listWard = res && res.data && res.data.data ?  res.data.data : [];
          }
        });
      }
    });
    // this.form_step1.get('addressNew').setValue(true);
  }

  onSearch(value: string): void {
    this.isLoading = true;
    this.searchChange$.next(value);

  }

  selectId($id) {
    if ($id) {
      this.distributorsService.detailDistributor($id).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.viewDetail = res.data;
      });
    }
  }


  select(ret: {}): void {
  }

  change(ret: {}): void {
  }

  handleCancel(): void {
    this.isVisible = false;
    this.avatar = [];
    this.background = [];
    this.viewDetail = null;

    if (this.changeTabEvent === 1) {
      this.form_step.reset();

    } else {
      this.form_step1.reset();
    }
  }

  showModal(): void {

    this.isVisible = true;
    this.changeTabEvent = 1;
  }

  changeTab(event) {
    this.introImage = []
    this.introVideo = []
    this.changeTabEvent = event;
    if (this.changeTabEvent === 1) {

      this.form_step.reset();
    } else {

      this.viewDetail = null;
      this.form_step1.reset();
      this.form_step1.get('addressNew').setValue(true);
    }
  }

  onSubmit() {

    if (this.changeTabEvent === 1) {


      this.isLoadingBtn = true;

      this.distributorsService.addIdDistributor(this.form_step.value).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {

        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Chọn nhà phân phối thành công'
          );

          this.viewDetail = null;
          this.form_step.reset();
          this.loadDataParent.emit(true);
          this.isVisible = false;

        } else {

          this.notification.create(
            'warning',
            'Cảnh báo',
            res.message
          );
        }
      }, (err) => {

        this.notification.create(
          'error',
          'Thất bại',
          err
        );
      });
      this.isLoadingBtn = false;

    } else {

      const form = this.form_step1;
      this.isLoadingBtn = true;
      let newForm;
      newForm = {...this.form_step1.value};
      // tslint:disable-next-line:radix
      newForm.country_id =  parseInt(this.form_step1.value.country_id.split('-')[0]);
      newForm.introImage = this.introImage.map(z => z.url);
      newForm.introVideo = this.introVideo;
      if (this.form_step1.value.country_id.split('-')[1] !== 'VN') {
        newForm.province_id = 0;
        newForm.district_id = 0;
        newForm.streetId = 0;
      }
      newForm.name = capitalizeFirstLetter(removeAllSpacingBetweenWords(this.form_step1.value.name));
      newForm.country_id = undefined;
      if(newForm.intro) {
        newForm.intro  = newForm.intro.trim();
      }

      // tslint:disable-next-line:radix
      newForm.countryId = parseInt(this.form_step1.value.country_id.split('-')[0]);
      if (newForm.addressNew) {
        newForm.province_id = null;
        newForm.district_id = null;
        newForm.address = null;
      } else {
        newForm.provinceNewId = null;
        newForm.wardNewId = null;
        newForm.addressNewName = null;
      }
      console.log('newFOr', newForm)
      this.distributorsService.addDistributor(newForm).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Tạo nhà phân phối thành công'
          );


          this.avatar = [];
          this.background = [];
          this.introImage = [];
          this.introVideo = [];
          this.form_step1.reset();
          this.loadDataParent.emit(true);
          this.isVisible = false;

        } else {

          this.notification.create(
            'warning',
            'Cảnh báo',
            res.message
          );
        }
        this.isLoadingBtn = false;

      }, (err) => {

        this.notification.create(
          'error',
          'Thất bại',
          err
        );
        this.isLoadingBtn = false;

      });
    }
  }

  getCities() {
    this.rootService.listCountries().pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.countries = res.data.items;
        }
      }
    );
  }

  citiChange(event) {
    if (event) {
      // this.country_id = event.split('-')[0];
      this.country_code = event.split('-')[1];

      if ( this.country_code  !== 'VN') {
        this.form_step1.controls.province_id.clearValidators();
        this.form_step1.controls.province_id.disable();
        this.form_step1.controls.district_id.clearValidators();
        this.form_step1.controls.district_id.disable();
        this.form_step1.controls.streetId.clearValidators();
        this.form_step1.controls.streetId.disable();
        this.form_step1.controls.provinceNewId.clearValidators();
        this.form_step1.controls.provinceNewId.disable();
        this.form_step1.controls.wardNewId.clearValidators();
        this.form_step1.controls.wardNewId.disable();

        this.form_step1.controls.province_id.setValue(null);
        this.form_step1.controls.district_id.setValue(null);
        this.form_step1.controls.streetId.setValue(null);
        this.form_step1.controls.provinceNewId.setValue(null);
        this.form_step1.controls.wardNewId.setValue(null);
        return;
      }
      this.form_step1.controls.province_id.setValidators(Validators.required);
      this.form_step1.controls.province_id.enable();
      this.form_step1.controls.district_id.setValidators(Validators.required);
      this.form_step1.controls.district_id.enable();
      this.form_step1.controls.streetId.setValidators(Validators.required);
      this.form_step1.controls.streetId.enable();

      this.form_step1.controls.provinceNewId.setValidators(Validators.required);
      this.form_step1.controls.provinceNewId.enable();
      this.form_step1.controls.wardNewId.setValidators(Validators.required);
      this.form_step1.controls.wardNewId.enable();
    } else {
      this.form_step1.controls.province_id.clearValidators();
      this.form_step1.controls.province_id.disable();
      this.form_step1.controls.district_id.clearValidators();
      this.form_step1.controls.district_id.disable();
      this.form_step1.controls.streetId.clearValidators();
      this.form_step1.controls.streetId.disable();
      this.form_step1.controls.provinceNewId.clearValidators();
      this.form_step1.controls.provinceNewId.disable();
      this.form_step1.controls.wardNewId.clearValidators();
      this.form_step1.controls.wardNewId.disable();

      this.form_step1.controls.province_id.setValue(null);
      this.form_step1.controls.district_id.setValue(null);
      this.form_step1.controls.streetId.setValue(null);
      this.form_step1.controls.provinceNewId.setValue(null);
      this.form_step1.controls.wardNewId.setValue(null);
    }

  }

  getDistrictsNew($event: any) {
    this.form_step1.get('wardNewId').setValue(null);
  }
  getDistricts($event: any) {
    this.districts = null;
    this.street = null;
    this.form_step1.get('district_id').setValue(null);
    this.form_step1.get('streetId').setValue(null);
    if ($event !== null) {
      this.rootService.listDistricts($event).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.districts = res.data.items;
      });
    }

  }

  getStreet($event: any) {
    this.street = null;
    this.form_step1.get('streetId').setValue(null);
    if ($event !== null) {
      this.rootService.listWards($event).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.street = res.data.items;
      });
    }
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
